import { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import { InnerSearch } from "../components/search/InnerSearch";
import { RealtedVideo } from "../components/realtedVideo/RealtedVideo";
import { AskedQuestions } from "../help_support/components/AskedQuestions";
import { HelpFilter } from "../components/HelpFilter/HelpFilter";
import { Paginator } from "primereact/paginator";

const innerSearch = {
  pageName: "FAQ’s",
  backSteps: "",
  breadcrumb: [
    {
      label: "Home",
      url: "/VZYSupport/helpSupport",
    },
    { label: "All FAQ’s" },
  ],
};

export const FaqList = () => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const [selectedCategoryIDs, setSelectedCategoryIDs] = useState([]);
  const [faqListData, setFaqListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [first, setFirst] = useState(0);
  const rows = 8;
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchFAQList = useCallback(
    async (pageNumber = 1, categoryIDs = selectedCategoryIDs) => {
      setLoading(true);
      setError("");

      try {
        const payload = {
          contentCode: "",
          contentTypeID: 1,
          categoryID: 0,
          isActive: 1,
          pageNumber,
          pageSize: rows,
          searchValue: "",
          CategoryIDs: categoryIDs,
        };

        const response = await axios.post(
          `${apiBaseURL}/api/VZYHelpSupport/FetchFAQ`,
          payload,
          { headers: { "Content-Type": "application/json" } },
        );

        const result = response?.data?.result;
        setFaqListData(result?.fAQs ?? []);
        setTotalRecords(result?.totalRecords ?? 0);
      } catch (err) {
        setError("Failed to load FAQs.");
      } finally {
        setLoading(false);
      }
    },
    [rows, selectedCategoryIDs],
  );

  useEffect(() => {
    fetchFAQList(1);
  }, [fetchFAQList]);

  const onPageChange = (e) => {
    setFirst(e.first);
    fetchFAQList(e.page + 1, selectedCategoryIDs);
  };

  return (
    <>
      <InnerSearch innerSearch={innerSearch} />

      <section className="inner-page-details">
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              <HelpFilter
                title="All FAQ’s"
                filterIds="1"
                onApplyFilters={(ids) => {
                  setSelectedCategoryIDs(ids);
                  setFirst(0);
                  fetchFAQList(1, ids);
                }}
              />

              <div className="faq-accordian">
                <AskedQuestions faqListData={faqListData} />

                {/* {!loading && !error && faqListData.length === 0 && (
                  <p>Data not found.</p>
                )} */}

                {/* {totalRecords > rows && (
                  <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalRecords}
                    onPageChange={onPageChange}
                    className="mt-3"
                  />
                )} */}
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={totalRecords}
                  onPageChange={onPageChange}
                  className="mt-3"
                />

                {loading && <p className="text-center mt-2">Loading...</p>}
              </div>
            </div>

            <div className="col-md-3">
              <h4 className="detail-page-sidebar-title">Related Videos</h4>
              <div>
                <RealtedVideo />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
